// Dependencies
import React, { Fragment, FunctionComponent } from 'react'

// Components
import { Button } from 'component-library/button'
import { FloatContainer } from 'component-library/float-container/float-container'
import { Icon } from 'component-library/icon'
import { ConditionallyRender } from 'components/utilities/conditionally-render'

// Styles
import {
  NavbarButtonsWrapper,
  NavbarContent,
  NavbarContainer,
  NavItemContainer,
  NavListContainer,
  NavbarLogo,
  FloatContainerCloseIconWrapper
} from './navbar.styles'

// Types
import { NavbarProps, NavItemProps, NavListProps } from './navbar.types'

// Assets
import logo from './assets/proenem.svg'

export const Navbar: FunctionComponent<NavbarProps> = ({
  navOptionsCompositions,
  isFloatContainerOpened,
  floatContainerComposition,
  userActionElement,
  handleFloatContainerClick
}) => {
  return (
    <NavbarContainer>
      <NavbarContent>
        <NavbarLogo src={logo} />

        <div className="wrapper">
          <ConditionallyRender
            minimumBreakpoint="tablet"
            shouldRender={!!navOptionsCompositions}
            content={
              <div className="nav-list-wrapper">
                <NavList content={navOptionsCompositions} />
              </div>
            }
          />

          <ConditionallyRender
            maximumBreakpoint="tablet"
            content={
              <NavbarButtonsWrapper>
                <Button
                  className="menu"
                  variant="primary"
                  borderType="medium"
                  handleClick={handleFloatContainerClick}
                  iconElement={<Icon name="menu" color="#fff" size={24} />}
                />

                {userActionElement}
              </NavbarButtonsWrapper>
            }
          />
        </div>
      </NavbarContent>

      {!!isFloatContainerOpened && (
        <FloatContainer
          headerComposition={
            <FloatContainerCloseIconWrapper onClick={handleFloatContainerClick}>
              <Icon name="close" size={24} color="#3A3E47" />
            </FloatContainerCloseIconWrapper>
          }
          content={floatContainerComposition}
        />
      )}
    </NavbarContainer>
  )
}

export const NavItem: FunctionComponent<NavItemProps> = ({
  label,
  handleClick
}) => {
  return (
    <NavItemContainer className="gabarito-navitem" onClick={handleClick}>
      {label}
    </NavItemContainer>
  )
}

export const NavList: FunctionComponent<NavListProps> = ({
  direction,
  content
}) => {
  return <NavListContainer direction={direction}>{content}</NavListContainer>
}
